module.exports = __webpack_public_path__ + "media/components/country-flag/static/aw-593944ba60efbed601dc91b8b7564b91.svg";